import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

const router = new Router({
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'cursos',
      component: Home,
      meta: { requiresAuth: true }
    },
    {
      path: '/curso/:id',
      name: 'curso',
      component: () => import('./views/Course.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/leccion/:id',
      name: 'leccion',
      component: () => import('./views/Lesson.vue'),
      meta: { requiresAuth: true }
    },
    // {
    //   path: '/perfil',
    //   name: 'perfil',
    //   component: () => import('./views/Profile.vue'),
    //   meta: { requiresAuth: true }
    // },
    {
      path: '/registro',
      name: 'registro',
      component: () => import('./views/Register.vue'),
      meta: { noAuth: true }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue'),
      meta: { noAuth: true }
    },
    {
      path: '/validar/:chunk',
      name: 'validar',
      component: () => import('./views/Validate.vue'),
      meta: { noAuth: true }
    },
    {
      path: '/recuperar',
      name: 'recuperar',
      component: () => import('./views/Recover.vue'),
      meta: { noAuth: true }
    },
    {
      path: '/recuperar/:token',
      name: 'recuperarToken',
      component: () => import('./views/UpdatePassword.vue'),
      meta: { noAuth: true }
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!localStorage.getItem('token')) {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath,
        },
      });
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.noAuth)) {
    if (localStorage.getItem('token')) {
      next({
        path: '/',
        query: {
          redirect: to.fullPath,
        },
      });
    } else {
      next();
    }
  } else {
    next();
  }
})

export default router